<template>
  <div class="layout-main">
    <div class="wp-con clearfix">
      <div class="official-left">
        <UserBox
          :xla="{
            show: 'home_user_module_show',
            click: 'home_user_module_click'
          }"
        />
        <ServerList
          :xla="{
            show: 'home_server_module_show',
            click: 'home_server_module_click',
            itemClick: 'home_server_item_click'
          }"
        />
        <GameIntro :list="game.game_intro_list || []" />
      </div>
      <div class="official-right">
        <ActBanner :list="game.slice_list || []" />
        <NoticeList :list="game.notice_list || []" />
        <RoleIntro :list="game.role_intro_list || []" />
      </div>
      <GameCut :list="game.screen_list || []" />
    </div>
  </div>
</template>

<script>
import UserBox from '~/components/game-offical/common/UserBox'
import ActBanner from '~/components/game-offical/home/ActBaner'
import ServerList from '~/components/game-offical/common/ServerList'
import NoticeList from '~/components/game-offical/home/NoticeList'
import GameIntro from '~/components/game-offical/home/GameIntro'
import RoleIntro from '~/components/game-offical/home/RoleIntro'
import GameCut from '~/components/game-offical/home/GameCut'
export default {
  layout: 'game',
  components: {
    UserBox,
    ActBanner,
    ServerList,
    NoticeList,
    GameIntro,
    RoleIntro,
    GameCut
  },
  computed: {
    game() {
      return this.$store.state.game.info
    }
  },
  fetch({ store, params, error }) {
    return store
      .dispatch('game/getGameDetail', params.game_id)
      .catch((err) => error(err))
  },
  mounted() {
    this.$xlaGamePush('home_page_show')
  }
}
</script>
